"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultCurrency = exports.mapISO4217toCurrency = exports.isISO4217 = exports.ISO4217StringsStruct = exports.isCurrency = exports.CurrencyStruct = void 0;
const superstruct_1 = require("superstruct");
exports.CurrencyStruct = (0, superstruct_1.enums)(['$', '£', '€', '₽', '¥', '₹', '₿', '₴', '₺']);
function isCurrency(value) {
    return exports.CurrencyStruct.is(value);
}
exports.isCurrency = isCurrency;
exports.ISO4217StringsStruct = (0, superstruct_1.enums)([
    'USD',
    'GBP',
    'EUR',
    'RUB',
    'JPY',
    'INR',
    'BTC',
    'UAH',
    'TRY',
]);
function isISO4217(value) {
    return exports.ISO4217StringsStruct.is(value);
}
exports.isISO4217 = isISO4217;
function mapISO4217toCurrency(isoString) {
    let map = {
        USD: '$',
        GBP: '£',
        EUR: '€',
        RUB: '₽',
        JPY: '¥',
        INR: '₹',
        BTC: '₿',
        UAH: '₴',
        TRY: '₺',
    };
    return map[isoString.toUpperCase()];
}
exports.mapISO4217toCurrency = mapISO4217toCurrency;
exports.DefaultCurrency = '€';
//# sourceMappingURL=curency.js.map